$shm_projects_release_notes_view $mol_view
	notes null
	sub /
		<= Audience $mol_select
			hint \Для кого
			value? <=> audience? \user
			dictionary *
				technical \Технический директор
				product \Продуктовый директор
				executive \Генеральный директор
				user \Пользователь
		<= Scope $mol_text
			text <= scope_text \
		<= Content $mol_text
			text <= content_text \
